import { List, useTable, ShowButton, CreateButton } from '@refinedev/antd';
import { Table, Tag, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { BidiText, MonoCode, formatDateBidi } from '@lebinatikra/rtl-utils';

interface CommunityRow {
  id: string;
  name: string;
  slug: string;
  profile: string;
  data_region: string;
  created_at: string;
}

export function CommunityList() {
  const { t } = useTranslation();
  const { tableProps, searchFormProps } = useTable<CommunityRow>({
    resource: 'communities',
    pagination: { pageSize: 25 },
    onSearch: (data) => {
      const name = (data as { name?: string }).name;
      return name ? [{ field: 'name', operator: 'contains', value: name }] : [];
    },
  });

  return (
    <List headerButtons={() => <CreateButton>{t('actions.create_community')}</CreateButton>}>
      <Input.Search
        placeholder={t('common.search')}
        style={{ maxWidth: 320, marginBottom: 16 }}
        onSearch={(value) => searchFormProps.form?.setFieldValue('name', value)}
        allowClear
      />
      <Table {...tableProps} rowKey="id">
        <Table.Column<CommunityRow>
          dataIndex="name"
          title={t('common.name')}
          render={(v) => (
            // rtl-utils:bidi-wrapped
            <BidiText>{v}</BidiText>
          )}
        />
        <Table.Column<CommunityRow>
          dataIndex="slug"
          title={t('fields.slug')}
          render={(v) => (
            // rtl-utils:bidi-wrapped
            <MonoCode>{v}</MonoCode>
          )}
        />
        <Table.Column<CommunityRow>
          dataIndex="profile"
          title={t('fields.profile')}
          render={(v) => <Tag>{v}</Tag>}
        />
        <Table.Column<CommunityRow>
          dataIndex="data_region"
          title={t('fields.data_region')}
          render={(v) => <Tag color="geekblue">{v}</Tag>}
        />
        <Table.Column<CommunityRow>
          dataIndex="created_at"
          title={t('common.created_at')}
          render={(v) => formatDateBidi(v)}
        />
        <Table.Column<CommunityRow>
          title={t('common.actions')}
          render={(_, record) => (
            <ShowButton hideText size="small" recordItemId={record.id} />
          )}
        />
      </Table>
    </List>
  );
}
